import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100vh',
  height: '100vh',
  overflow: 'hidden',
});

const ContentColumn = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  height: '100vh',
  overflow: 'hidden',
  backgroundColor: '#F4F2EB',
});

const Main = styled('div')(({ theme }) => ({
  flex: 1,
  overflow: 'auto',
  minHeight: 0,
  backgroundColor: '#F4F2EB',
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);

  return (
    <StyledRoot>
      <Nav openNav={open} onCloseNav={() => setOpen(false)} />

      <ContentColumn>
        <Header onOpenNav={() => setOpen(true)} />
        <Main>
          <Outlet />
        </Main>
      </ContentColumn>
    </StyledRoot>
  );
}
